import React, { useContext } from "react";
import { DataContext } from "../../contexts/DataContext";
import EventEdit from "../Events/EventEdit";
import ScheduleEdit from "../Schedule/ScheduleEdit";
import SavePanel from "../UI/Form/SavePanel";
import Modal from "../UI/Modal/Modal";
import Panel from "../UI/Panel/Panel";
import PanelContent from "../UI/Panel/PanelContent";
import PanelTitle from "../UI/Panel/PanelTitle";

export default function ScheduleEditor({
  scheduleEvent,
  onSave,
  onCancel,
  selectEvent,
}) {
  const { updateRound, deleteRound } = useContext(DataContext);

  return (
    <Modal
      style={{ width: "50%" }}
      show={scheduleEvent}
      onCancel={() => {
        selectEvent();
        onCancel();
      }}
    >
      {scheduleEvent && (
        <Panel style={{ marginTop: "-25%" }}>
          <PanelTitle title={"Schedule Edit"}>
            <div>{scheduleEvent._id}</div>
          </PanelTitle>
          <PanelContent>
            <ScheduleEdit
              event={scheduleEvent}
              onChange={(s) => {
                selectEvent(s);
              }}
            />
          </PanelContent>

          <SavePanel
            showDelete={scheduleEvent._id}
            onDelete={() => {
              deleteRound({ data: scheduleEvent }).then(() => {
                selectEvent();
                onSave();
              });
            }}
            onSave={() => {
              updateRound({
                data: { ...scheduleEvent, event: scheduleEvent?.event?._id },
              }).then(() => {
                selectEvent();
                onSave();
              });
            }}
            onCancel={() => {
              selectEvent();
              onCancel();
            }}
          ></SavePanel>
        </Panel>
      )}
    </Modal>
  );
}
